import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { ANSWER_TYPE_HINTS, ANSWER_TYPE_LABELS, ANSWER_TYPE_ORDER, } from '../answer-type-labels';
/**
 * The shape a value takes: the kind select, and the option list when the
 * kind is `options`. A form question's answer and a signal's resolved value
 * share every kind, so they share this field. `showHint` is for form
 * questions only: a signal is never asked, so "asks again" does not apply.
 */
export function AnswerTypeField({ label, value, onChange, showHint = false, }) {
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "space-y-1.5", children: [_jsx(Label, { className: "text-xs", children: label }), _jsx("select", { value: value.kind, onChange: e => onChange(buildDefaultAnswerType(e.target.value, value)), className: "w-full h-8 rounded-md border bg-background px-2 text-xs", children: ANSWER_TYPE_ORDER.map(kind => (_jsx("option", { value: kind, children: ANSWER_TYPE_LABELS[kind] }, kind))) }), showHint && ANSWER_TYPE_HINTS[value.kind] && (_jsx("p", { className: "text-[11px] text-muted-foreground", children: ANSWER_TYPE_HINTS[value.kind] }))] }), value.kind === 'options' && (_jsxs("div", { className: "space-y-1.5", children: [_jsx(Label, { className: "text-xs", children: "Options (one per line)" }), _jsx(Textarea, { value: value.options.join('\n'), onChange: e => onChange({
                            kind: 'options',
                            options: e.target.value
                                .split('\n')
                                .map(o => o.trim())
                                .filter(Boolean),
                        }), placeholder: 'owner\ntenant\nsomething else', className: "text-xs resize-y" })] }))] }));
}
export function buildDefaultAnswerType(nextKind, previous) {
    if (nextKind === previous.kind)
        return previous;
    switch (nextKind) {
        case 'options':
            return { kind: 'options', options: ['option 1', 'option 2'] };
        case 'integer':
            return { kind: 'integer' };
        default:
            return { kind: nextKind };
    }
}
//# sourceMappingURL=AnswerTypeField.js.map